import type { FirebaseRepository } from './FirebaseRepository'
import type { MobxDocument } from '../types'
import {
  ObservableModelWithDecorators,
  emptyCollection,
  emptyModel,
} from '../firestore-mobx/model'
import { empty } from '../firestore/UserProfileFavoriteCatalog/schema'
import type { FirestoreUserProfileFavoriteCatalog } from '../firestore/UserProfileFavoriteCatalog'

export class UserProfileFavoriteCatalog extends ObservableModelWithDecorators<FirestoreUserProfileFavoriteCatalog> {
  static empty(repository: FirebaseRepository) {
    return emptyModel(repository, this, empty)
  }

  static emptyCollection(repository: FirebaseRepository) {
    return emptyCollection(repository, this, empty)
  }

  constructor(
    repository: FirebaseRepository,
    doc: MobxDocument<FirestoreUserProfileFavoriteCatalog>
  ) {
    super(repository, doc)
  }
}
